import "core-js/modules/es.array.concat";
import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Thomas Barry

 Description: Generates a messaging component
 */
import React from 'react';
import PropTypes from 'prop-types';
import Block from '../block/Block';
import useBrand from '../hooks/use-brand';
import useStrings from '../hooks/use-strings';
import useCustomWFFonts from '../hooks/use-custom-wf-fonts';
import { getClasses } from '../../lib/style-utils/style-utils';
import getMessageIcon from './get-message-icon';
import MessageContent from './MessageContent';
import AriaLiveMessage from '../aria-live/AriaLiveMessage';
import Translatable from '../translatable/Translatable';
import AccessibilityText from '../accessibility-text/AccessibilityText';
import styles from './Message.less';
var roles = {
  alert: 'alert',
  error: 'alert',
  warn: 'alert'
};

var Message = function Message(_ref) {
  var _ref$level = _ref.level,
      level = _ref$level === void 0 ? 'alert' : _ref$level,
      content = _ref.content,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? [] : _ref$children,
      filled = _ref.filled,
      dark = _ref.dark,
      inline = _ref.inline,
      announce = _ref.announce,
      handleContentClick = _ref.handleContentClick;
  var brand = useBrand();
  var useWFFonts = useCustomWFFonts();

  var _useStrings = useStrings(),
      getString = _useStrings.getString;

  if (typeof content === 'undefined' && children.length === 0) {
    return null;
  }

  var _getMessageIcon = getMessageIcon(level),
      Icon = _getMessageIcon.Icon,
      className = _getMessageIcon.className,
      titleId = _getMessageIcon.titleId;

  var title = getString(titleId);
  var classes = ['message', className, filled && 'filled', inline && 'inline', dark && 'dark', useWFFonts && 'useWFFonts'];
  var classNames = getClasses({
    styles: styles,
    classes: classes,
    brand: brand
  }); // When using the Aria Live region to announce the message (announce=true), don't
  // add the role prop to the container.

  var ariaProps = {};

  if (!announce) {
    ariaProps.role = roles[level.toLowerCase()];
  }

  return /*#__PURE__*/React.createElement(Block, {
    layout: true,
    flex: true,
    horizontal: true,
    stretch: true,
    className: classNames,
    role: "region",
    "aria-label": getString('global.alerts')
  }, /*#__PURE__*/React.createElement(AccessibilityText, {
    el: "span",
    tabIndex: "-1"
  }, /*#__PURE__*/React.createElement(Translatable, {
    id: "global.begin.region"
  })), /*#__PURE__*/React.createElement(Block, {
    layout: true,
    vertical: true,
    justifyStart: true,
    center: true,
    className: styles['iconContainer']
  }, /*#__PURE__*/React.createElement(Icon, {
    title: title,
    decorative: true
  })), /*#__PURE__*/React.createElement(Block, {
    flex: true,
    basisMax: true,
    layout: true,
    vertical: true,
    justifyCenter: true,
    className: styles['contentContainer']
  }, /*#__PURE__*/React.createElement(MessageContent, _extends({
    content: content,
    handleContentClick: handleContentClick
  }, ariaProps), children)), announce && /*#__PURE__*/React.createElement(AriaLiveMessage, {
    message: "".concat(title, " ").concat(content),
    "aria-live": "polite"
  }));
};

Message.propTypes = {
  content: PropTypes.string,
  level: PropTypes.string,
  filled: PropTypes.bool,
  dark: PropTypes.bool,
  inline: PropTypes.bool,
  announce: PropTypes.bool,
  handleContentClick: PropTypes.func
};
Message.defaultProps = {
  announce: false,
  handleContentClick: function handleContentClick() {
    return undefined;
  }
};
export default Message;